import { FallbackAppLayout } from 'apps/employer_dashboard/components/FallbackAppLayout'
import { ErrorBoundaryInfo } from 'shared/dashboard/ErrorBoundaryInfo'

export function FallbackErrorPage () {
  return (
    <FallbackAppLayout>
      <div className='grow flex flex-col items-center justify-center'>
        <ErrorBoundaryInfo
          heading='We could not render the dashboard because of an unexpected error'
          message='Our team has been notified and is looking into it'
        />
      </div>
    </FallbackAppLayout>
  )
}
